import { Column } from "../../../../../components/Table/types";
import { Columns } from "./types";

const columns: Column<Columns>[] = [
  { name: "marketplace", label: "Источник" },
  { name: "period", label: "Период", props: { sx: { minWidth: 200 } } },
  {
    name: "turnoverValue",
    label: "Оборот, " + String.fromCharCode(8381),
    props: { sx: { minWidth: 120 } },
  },
  {
    name: "turnoverFraction",
    label: "Доля, %",
    props: { sx: { minWidth: 100 } },
  },
  {
    name: "marginalityValute",
    label: "Маржа, " + String.fromCharCode(8381),
    props: { sx: { minWidth: 120 } },
  },
  {
    name: "marginalityFraction",
    label: "Доля, %",
    props: { sx: { minWidth: 100 } },
  },
  {
    name: "marginalityPercent",
    label: "Маржа, %",
    props: { sx: { minWidth: 120 } },
  },
  { name: "markup", label: "Наценка", props: { sx: { minWidth: 120 } } },
];
export default columns;
